import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-help-doc-tt-changed',
  templateUrl: './help-doc-tt-changed.component.html',
  styleUrls: ['./help-doc-tt-changed.component.css']
})
export class HelpDocTtChangedComponent implements OnInit {
    public selectedBgHelpDocTTChanged: string = 'TODO';

    public setting?: Setting;

    public selectListLanguages: Item[] = [];

    public itemsListHelpDocChanged: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(837))[0];
    }

    private async loadLanguages() {
        this.selectListLanguages = await this.datatask.Post(57);
    }

    private async loadHelpDocChanged() {
        if (!this.setting) return;

        const sendObject = {
            ...this.setting,
            bg_helpdocttchanged: this.selectedBgHelpDocTTChanged
        }

        return this.itemsListHelpDocChanged = await this.datatask.Post(838, sendObject);
    }

    public onTabChanged() {
        this.loadHelpDocChanged();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'language_id':
                this.loadHelpDocChanged();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadLanguages();
        this.loadHelpDocChanged();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    language_id: string;
    filterval: string;
}
